import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as DiscountsActions } from "reducers/discounts";
import gaEventTracker, { events } from "util/gaEventTracker";
import * as i18n from "util/i18n";

const useDiscountFilters = (optionThirdParty) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { discountFilters } = useSelector((state) => state.discounts);

    const tagOptionsCommon = () => {
        const tagOptions = {
            status: { id: "status", text: i18n.get("payThirdParties.status.label") },
            dateFrom: { id: "dateRange", text: i18n.get("payThirdParties.dateRange.label") },
            // amountFrom: { id: "amountFrom", text: i18n.get("payThirdParties.amountFrom.label") },
            // amountTo: { id: "amountTo", text: i18n.get("payThirdParties.amountTo.label") },
            idBatch: { id: "idBatch", text: i18n.get("", "ID de Lote") },
        };

        return tagOptions;
    };
    const commonTagOptions = tagOptionsCommon();

    const tagOptions = {
        "thirdPayment.providers": {
            ...commonTagOptions,
            receiver: { id: "providers", text: i18n.get("thirdPayment.providers.label") },
        },
        "thirdPayment.assets": {
            ...commonTagOptions,
            recurrent: { id: "assets", text: i18n.get("thirdPayment.assets.label") },
        },
    };

    const actionDispatch = (filter) => {
        gaEventTracker.triggerEvent(events.echeq_filtrar());

        dispatch(DiscountsActions.setDiscountFilters(filter));
        dispatch(DiscountsActions.loadListDiscountRequest());
    };

    // useEffect(() => {
    //     const initialValues = {
    //         dateFrom: null,
    //         dateTo: null,
    //         status: "",
    //         idBatch: "",
    //     };
    //     actionDispatch(initialValues);
    //     // dispatch(DiscountsActions.setDiscountFilters(initialValues));
    // }, []);

    useEffect(() => {
        const activeTags = Object.entries(discountFilters)
            .filter((activeFilters) => !activeFilters.includes("") && !activeFilters.includes(null))
            .map((filter) => filter[0])
            .filter((filterKey) => !!tagOptions[optionThirdParty][filterKey])
            .map((key) => tagOptions[optionThirdParty][key]);

        setTags(activeTags);
    }, [discountFilters]);

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;
        if (deletedFilter !== "dateRange" && deletedFilter !== "status" && deletedFilter !== "idBatch") {
            const tagFilters = {
                ...discountFilters,
                [deletedFilter]: "",
            };
            actionDispatch(tagFilters);
            return;
        }

        if (deletedFilter === "dateRange") {
            const tagFilters = {
                ...discountFilters,
                dateFrom: null,
                dateTo: null,
            };
            actionDispatch(tagFilters);
            return;
        }
        if (deletedFilter === "status") {
            const tagFilters = {
                ...discountFilters,
                status: "",
            };
            actionDispatch(tagFilters);
            return;
        }
        if (deletedFilter === "idBatch") {
            const tagFilters = {
                ...discountFilters,
                idBatch: "",
            };
            actionDispatch(tagFilters);
        }
    };
    const handleCleanFilters = () => {
        const clearFilters = {
            ...discountFilters,
            dateFrom: null,
            dateTo: null,
            idBatch: "",
            status: "",
            typePayment: "PH",
        };
        actionDispatch(clearFilters);
    };

    return { tags, handleDelete, handleCleanFilters, setFilters: actionDispatch };
};

export default useDiscountFilters;
